<template>
  <s-wrapper>
    <s-table-loader v-if="isLoadingSlots">
      <app-spinner variant="primary" size="md" />
    </s-table-loader>

    <div v-if="!isLoadingSlots && availableSlots.length">
      <s-table-header>
        <s-table-header-arrow content="flex-start" @click="moreDays('prev')">
          <custom-icons name="chevron-left-icon" :width="16" :height="16" />
        </s-table-header-arrow>

        <s-table-header-days>
          <s-table-header-day
            v-for="day in availableScheduleDays"
            :key="day.slot_date"
            :is-selected="day.slot_date === selectedScheduleDay"
            @click.native="selectScheduleDay(day.slot_date)"
          >
            {{ theDate(day.slot_date) }}
            {{ theWeekDay(day.slot_date) }}
          </s-table-header-day>
        </s-table-header-days>

        <s-table-header-arrow content="flex-end" @click="moreDays('next')">
          <custom-icons name="chevron-right-icon" :width="16" :height="16" />
        </s-table-header-arrow>
      </s-table-header>

      <s-table-slots>
        <s-table-button
          v-for="(slot, index) in listAvailableSlots(
            filteredAvailableSlots[selectedScheduleDay]
          )"
          :key="`${slot.slot_date}${index}`"
          @click.native="selectScheduleSlot(slot)"
          :is-selected="
            selectedScheduleSlot.hour === slot.hour &&
              selectedScheduleSlot.slot_id === slot.slot_id
          "
        >
          {{ slot.hour }}
        </s-table-button>
      </s-table-slots>

      <s-table-footer>
        <s-show-more-button
          v-if="filteredAvailableSlots[selectedScheduleDay].length >= 19"
          @click="showMore = !showMore"
        >
          <span class="mr-3">Ver todos os horários</span>
          <custom-icons
            :name="showMore ? 'chevron-up-icon' : 'chevron-down-icon'"
            :width="14"
            :height="14"
          />
        </s-show-more-button>
      </s-table-footer>
    </div>

    <SEmptyState v-if="!isLoadingSlots && !availableSlots.length">
      <h4>Nenhum horário encontrado!</h4>
      <p>Escolha outro profissional para seguir com o agendamento.</p>
    </SEmptyState>
  </s-wrapper>
</template>

<script>
import {
  SShowMoreButton,
  STableButton,
  STableFooter,
  STableHeader,
  STableHeaderArrow,
  STableHeaderDay,
  STableHeaderDays,
  STableLoader,
  STableSlots,
  SEmptyState,
  SWrapper
} from "./styles";
import CustomIcons from "../../CustomIcons.vue";
import AppSpinner from "../../AppSpinner";
import { formatDate, formatWeekDay } from "../../../utils/masks/formatSlotDate";

export default {
  name: "InstitutionScheduleTable",
  components: {
    SShowMoreButton,
    STableButton,
    STableFooter,
    STableHeader,
    STableHeaderArrow,
    STableHeaderDay,
    STableHeaderDays,
    STableLoader,
    STableSlots,
    SWrapper,
    SEmptyState,
    CustomIcons,
    AppSpinner
  },
  props: {
    doctor: {
      type: Object,
      default: () => {}
    },
    unitId: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      error: null,
      isLoadingSlots: false,
      availableSlots: [],
      currentPage: 0,
      showMore: false,
      selectedScheduleDay: null,
      selectedScheduleSlot: {}
    };
  },
  mounted() {
    this.getDoctorAvailableSlots();
  },
  methods: {
    async getDoctorAvailableSlots() {
      try {
        this.isLoadingSlots = true;
        const response = await this.$store.dispatch(
          "doctor/fetchDoctorsAvailables",
          { id: this.doctor.id, query: `unit_id=${this.unitId}` }
        );
        this.availableSlots = response.data;
      } catch (error) {
        this.error = error;
      } finally {
        this.isLoadingSlots = false;
      }
    },
    moreDays(action) {
      if (action === "prev" && this.currentPage > 0) {
        return this.currentPage--;
      }
      if (
        action === "next" &&
        this.currentPage < this.maxAvailableScheduleDays
      ) {
        return this.currentPage++;
      }
    },
    theWeekDay(value) {
      return formatWeekDay(value) || "";
    },
    theDate(value) {
      return formatDate(value);
    },
    selectScheduleDay(date) {
      this.selectedScheduleDay = date;
    },
    selectCurrentScheduleDay() {
      let scheduleDays = this.availableScheduleDays.map(day => day.slot_date);
      this.selectedScheduleDay = scheduleDays[0];
    },
    listAvailableSlots(slots) {
      let minSlots = {};
      Object.keys(slots).forEach((key, index) => {
        if (index <= 19) {
          minSlots[key] = slots[index];
        }
      });
      return this.showMore ? slots : minSlots;
    },
    selectScheduleSlot(slot) {
      this.selectedScheduleSlot = slot;
      this.$emit("selectSlot", slot);
    }
  },
  computed: {
    filteredAvailableSlots() {
      let reducedDays = this.availableSlots.reduce(
        (prevValue, currentValue) => {
          prevValue[currentValue.slot_date] = [
            ...(prevValue[currentValue.slot_date] || []),
            ...currentValue.slots.map(slot => ({
              slot_id: currentValue.id,
              slot_date: currentValue.slot_date,
              hour: slot
            }))
          ];
          return prevValue;
        },
        {}
      );
      return reducedDays;
    },
    availableScheduleDays() {
      let days = [];
      let slots = this.filteredAvailableSlots;

      Object.keys(slots)
        .slice(this.currentPage * 4, this.currentPage * 4 + 4)
        .filter(day => {
          if (slots[day]) {
            days.push({
              slot_date: day
            });
          }
        });
      return days;
    },
    maxAvailableScheduleDays() {
      return Math.ceil(Object.keys(this.filteredAvailableSlots).length / 4) - 1;
    }
  },
  watch: {
    availableScheduleDays() {
      if (this.availableScheduleDays.length) {
        this.selectCurrentScheduleDay();
      }
    },
    doctor(newVal, oldVal) {
      if (newVal !== oldVal) this.getDoctorAvailableSlots();
    }
  }
};
</script>
